import React, { useContext, useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { login, activateDealer } from "lib/actions";
import { User } from "context/AuthContext";
import {
  getUserProfile,
  updateUserProfile,
  bindSso,
  unBindSso,
  changePwd,
} from "pages/dashboard/profile/service";

export enum SSOType {
  GoogleSSO = "sso_google",
  MicrosoftSSO = "sso_microsoft",
}

export enum SSOPage {
  Activate,
  Login,
  Profile,
}
export type SSOPostData = {
  success: boolean;
  error?: {
    errorString?: string;
    errorCode?: number;
  };
  ssoType?: SSOType;
  data?: any;
};

export default function SSO() {
  const location = useLocation();

  const getMircrosoftCodeFromHash = () => {
    const hash = window.location?.hash;
    console.log("newWindow.location", window.location);
    if (!hash) {
      return;
    }
    const params = new URLSearchParams(hash.substring(1));
    const autoCode = params.get("code");
    return autoCode;
  };

  const getGoogleCodeFromQuery = () => {
    const params = new URLSearchParams(window.location?.search);
    const autoCode = params.get("code");
    return autoCode;
  };

  useEffect(() => {
    const index = window.location.href.indexOf("state");
    if (index < 0) {
      return;
    }
    const stateEndIndex = window.location.href.indexOf("&", index);
    const stateData =
      stateEndIndex > 0
        ? window.location.href.slice(index + 6, stateEndIndex)
        : window.location.href.slice(index + 6);

    console.log("stateData:", stateData);
    const { ssoType, fromPage, extraData } = JSON.parse(
      decodeURIComponent(stateData),
    );
    if (!ssoType) {
      return;
    }
    console.log("url data:", ssoType, fromPage);
    let authCode = "";
    if (ssoType === SSOType.MicrosoftSSO) {
      authCode = getMircrosoftCodeFromHash();
    } else if (ssoType === SSOType.GoogleSSO) {
      authCode = getGoogleCodeFromQuery();
    }

    if (!authCode) {
      return;
    }

    switch (fromPage) {
      case SSOPage.Login: {
        handleLogin(ssoType, authCode);
        break;
      }
      case SSOPage.Profile: {
        handleBind(ssoType, authCode);
        break;
      }
      case SSOPage.Activate: {
        handleActivate(
          ssoType,
          authCode,
          extraData?.passSalt,
          extraData?.token,
        );
        break;
      }
    }
    console.log("window.opener.postMessage");
  }, [location]);

  async function handleLogin(ssoType: SSOType, authCode: string) {
    const formData = new FormData();
    formData.set("authCode", authCode);
    formData.set("ssoType", ssoType);
    let data: SSOPostData;
    try {
      const response = await login(formData);

      const user: User = {
        id: response.user.id,
        email: response.user.email,
        accountName: response.user.organization.name,
        orgId: response.user.organization.id,
        role: response.user.role.name,
        token: response.token,
        phoneNumber: response.user.phoneNumber,
        name: response.user.firstName + " " + response.user.lastName,
        organization: response.user.organization,
      };
      data = { success: true, data: user, ssoType };
    } catch (error) {
      data = {
        success: false,
        ssoType,
        error: {
          errorString:
            "The user name or password is incorrect." +
            (error as Error)?.message,
        },
      };
    } finally {
      window.opener?.postMessage(JSON.stringify(data), "*");
    }
  }

  const handleBind = async (ssoType: SSOType, authCode: string) => {
    const response = await bindSso(authCode, ssoType);
    let data: SSOPostData;
    if (response.status !== 200) {
      data = {
        success: false,
        error: { errorString: "Failed to bind. Please try again later." },
      };
    } else {
      data = { success: true, ssoType };
    }

    window.opener?.postMessage(JSON.stringify(data), "*");
  };

  async function handleActivate(
    ssoType: SSOType,
    authCode: string,
    passSalt: string,
    token: string,
  ) {
    const formData = new FormData();
    formData.set("authCode", authCode);
    formData.set("ssoType", ssoType);
    let data: SSOPostData;
    const response = await activateDealer(passSalt, token, formData);
    if (Object.keys(response).length !== 0) {
      data = {
        success: false,
        ssoType,
        error: { errorString: "Failed to activate. Please try again later." },
      };
    } else {
      data = { success: true, ssoType };
    }

    window.opener?.postMessage(JSON.stringify(data), "*");
  }

  return (
    <div className="flex flex-col items-center justify-center h-full mr-6 mb-6 profile-page">
      <div
        className="mt-4 text-blue-500  inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
        role="status"
      ></div>
    </div>
  );
}
